{
  "nl": {
    "installment_term": {
      "actions": {
        "addUnits": "Units",
        "add_fraction": "Fractie toevoegen",
        "create": "Maak aan",
        "create_price_term": "Nieuwe regel",
        "delete": "Verwijderen",
        "deleteMultiple": "Verwijder...",
        "delete_cancel": "Annuleer",
        "edit": "Bewerken",
        "newInstallment": "Betalingsschijf",
        "publish_customer": "Publiceren voor klant",
        "selectAll": "Selecteer alle {total} betalingsschijven",
        "selectOne": "Selecteer tenminste 1 betalingsschijf",
        "take": "Neem"
      },
      "attributes": {
        "description": "Omschrijving",
        "installments_count": "{count} betalingsschijf | {count} betalingsschijven",
        "name": "Titel"
      },
      "labels": {
        "addAllSurcharges": "Alle huidige meerwerken",
        "addAllUnitsPrices": "Alle unitprijzen",
        "allUnitsAssigned": "Alle units toegevoegd",
        "amount": "Bedrag",
        "balanceFractionTypes": "Balans fractietypes",
        "balanceTotal": "Totaalbalans",
        "containsSurcharges": "Bevat meerwerken",
        "create_decision_first": "Deze optie wordt beschikbaar zodra je een beslissing hebt gemaakt.",
        "deleteInstallmentTerm": "Verwijder betalingsschijf",
        "description": "Beschrijving",
        "documents": "Documenten",
        "duplicate_price_type": "Er bestaat al een fractie met dit prijstype.",
        "editInstallmentTerm": "Bewerk betalingsschijf",
        "edit_description": "Bewerk beschrijving",
        "fixed": "Vast",
        "fixedAmount": "Vast bedrag van",
        "for": "van",
        "forEachUnit": "van elke unit",
        "fraction_types": {
          "absolute": "Vast bedrag",
          "relative": "Percentage"
        },
        "goToAmounts": "Selecteer bedragen",
        "installments": "Financiën",
        "installmentsTitle": "Betalingsschijf",
        "installments_all_projects": "Betaalschijven alle projecten",
        "invalidAmount": "Ongeldig bedrag",
        "list": "Lijst",
        "name": "Betalingsschijf #{count}",
        "noContainsSurcharges": "Bevat geen meerwerken",
        "noInstallmentsToPay": "Geen betalingen in behandeling",
        "noUnitsClick": "Nog geen units voor dit project, klik hier om toe te voegen",
        "ofThe": "van",
        "price_types": {
          "custom_amount": "Andere",
          "price_value": "Het totaalbedrag",
          "price_value_construction": "De constructie-aandeelwaarde",
          "price_value_construction_existing": "De bestaande constructie-aandeelwaarde",
          "price_value_fees": "De architect/Ingenieur vergoedingsaandeelwaarde",
          "price_value_land": "De grondaandeelwaarde",
          "surcharge": "Meerwerken",
          "unit": "Unitprijzen"
        },
        "projectUnitsTotal": "{project_name} heeft {units_count_max} units in totaal",
        "publish_now": "Publiceer nu?",
        "rules": "Betalingsregels",
        "rules_subtitle": "Definieer welk percentage of bedrag geïnd moet worden",
        "save_explainer": "Deze betaalschijven zichtbaar maken voor uw klanten? Of opslaan en later publiceren?",
        "selectUnits": "Selecteer units",
        "selected": "{selected} betalingsschijf geselecteerd. | {selected} betalingsschijven geselecteerd.",
        "shortcuts": "Shortcuts",
        "show_installment_terms_for": "Toon betaalschijven voor",
        "step1Info": "Voeg omschrijving toe",
        "step2Subtitle": "Selecteer het project om alle units in één keer op te nemen.",
        "step2Title": "Welke units zijn gerelateerd aan deze betalingsschijf?",
        "surcharges": "Meerwerken",
        "total": "Totaal",
        "totalFixed": "Totaal vast",
        "totalPaid": "Totaal betaald",
        "totalRequested": "Totaal gefactureerd",
        "totalSelected": "Alle {total} betalingsschijven zijn geselecteerd.",
        "totalSurcharges": "Totaal meerwerken",
        "totalUnpaid": "Totaal onbetaald",
        "unitSelected": "Geen units geselecteerd | 1 unit geselecteerd | {count} units geselecteerd",
        "units": "Units"
      },
      "navigation": {
        "backToInstallmentTerms": "Terug naar overzicht betalingsschijven"
      },
      "placeholders": {
        "amount": "Kies een vast bedrag of een percentage van de verkoopswaarde of meerwerken",
        "description": "Bijv. 10% - Na het storten van de betonplaat op de eerste verdieping ....",
        "due_date": "Stel een datum in waarop de betalingsschijf moet zijn voldaan",
        "employees": {
          "new": {
            "subtitle": "Voeg betalingsschijven toe en houd hun status bij",
            "title": "Creëer een financieel overzicht"
          }
        },
        "installmentTermFractionNotice": "De bedragen kunnen niet meer worden aangepast aangezien sommige betalingsschijven al bezorgd werden aan de koper",
        "name": "B.v. betalingsschijf #1, Betalingsschijf - Meerwerken",
        "summary": "Samenvatting",
        "surcharge": "meerwerk"
      },
      "toasts": {
        "bulk_create": "Betalingsschijf succesvol aangemaakt | Betalingsschijven succesvol aangemaakt",
        "bulk_delete": "Betalingsschijf succesvol verwijderd | Betalingsschijven succesvol verwijderd",
        "bulk_update": "Betalingsschijf succesvol aangepast | Betalingsschijven succesvol aangepast",
        "delete": "Betalingsschijf succesvol verwijderd",
        "update": "Betalingsschijf succesvol aangepast"
      },
      "validation": {
        "fixedFractionLabel": "{price_type} is al gecombineerd met {fraction_type} in een andere bestaande betalingsschijf. Alleen {fraction_type} is toegestaan om consistentie te bewaren.",
        "maxLengthName": "Naam is te lang",
        "needDescription": "Omschrijving vereist",
        "needInstallmentTermFraction": "Een betalingsschijf is vereist",
        "needName": "Naam vereist",
        "needUniquePricesTypes": "Regels kunnen niet hetzelfde prijstype hebben binnen een betalingsschijf",
        "needValidTerm": "Bedrag kan niet 0 zijn. Het type moet bestaan",
        "selectInstallmentTerm": "Selecteer tenminste 1 betalingsschijf",
        "selectUnit": "Selecteer ten minste 1 unit"
      }
    }
  }
}